<template>
  <div ref="root" class="share">
    <button
      class="btn btn-soft"
      type="button"
      aria-haspopup="true"
      :aria-expanded="open ? 'true' : 'false'"
      aria-label="Share"
      @click.stop="onShareClick"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="18" cy="5" r="3" />
        <circle cx="6" cy="12" r="3" />
        <circle cx="18" cy="19" r="3" />
        <path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4" />
      </svg>
      <b>Share</b>
    </button>

    <div v-show="open" class="share-menu" role="menu">
      <a class="sm-item" :href="links.x" target="_blank" rel="noopener" role="menuitem" @click="close">
        <svg class="brand" viewBox="0 0 24 24" aria-hidden="true"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg>Share on X
      </a>
      <a class="sm-item" :href="links.linkedin" target="_blank" rel="noopener" role="menuitem" @click="close">
        <svg class="brand" viewBox="0 0 24 24" aria-hidden="true"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.225 0z" /></svg>Share on LinkedIn
      </a>
      <a class="sm-item" :href="links.whatsapp" target="_blank" rel="noopener" role="menuitem" @click="close">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 11.5a8.5 8.5 0 01-12 7.6L3 21l1.9-6A8.5 8.5 0 1121 11.5z" /></svg>WhatsApp
      </a>
      <a class="sm-item" :href="links.email" role="menuitem" @click="close">
        <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 6 9-6" /></svg>Email
      </a>
      <button class="sm-item" type="button" role="menuitem" @click="copy">
        <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="9" y="9" width="11" height="11" rx="2" /><path d="M5 15V5a2 2 0 012-2h10" /></svg><span>{{ copied ? 'Copied!' : 'Copy link' }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShareMenu',
  props: {
    title: { type: String, default: 'Decast recording' },
    // optional explicit URL to share (e.g. a clip deep-link); defaults to current page
    url: { type: String, default: '' },
  },
  data() {
    return { open: false, copied: false };
  },
  computed: {
    shareUrl() {
      return this.url || (typeof window !== 'undefined' ? window.location.href : '');
    },
    // recomputed lazily; location.href is current at click time anyway
    links() {
      const url = this.shareUrl;
      const u = encodeURIComponent(url);
      const t = encodeURIComponent(this.title);
      return {
        x: `https://twitter.com/intent/tweet?url=${u}&text=${t}`,
        linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${u}`,
        whatsapp: `https://wa.me/?text=${encodeURIComponent(`${this.title} ${url}`)}`,
        email: `mailto:?subject=${t}&body=${encodeURIComponent(url)}`,
      };
    },
  },
  mounted() {
    this._onDocClick = (e) => {
      if (this.$refs.root && !this.$refs.root.contains(e.target)) this.close();
    };
    this._onKey = (e) => {
      if (e.key === 'Escape') this.close();
    };
    document.addEventListener('click', this._onDocClick);
    document.addEventListener('keydown', this._onKey);
  },
  beforeDestroy() {
    document.removeEventListener('click', this._onDocClick);
    document.removeEventListener('keydown', this._onKey);
  },
  methods: {
    onShareClick() {
      const url = this.shareUrl;
      // native share sheet on mobile
      if (navigator.share && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) {
        navigator.share({ title: this.title, url }).catch(() => {});
        return;
      }
      this.open = !this.open;
    },
    close() {
      this.open = false;
    },
    copy() {
      const url = this.shareUrl;
      const done = () => {
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
          this.close();
        }, 850);
      };
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(done).catch(done);
      } else {
        done();
      }
    },
  },
};
</script>
